<template>
  <div
    :class="{
      w600: groupByRole,
      w400: !groupByRole,
    }"
  >
    <table v-if="!isEmptyData(driver.milerates)" class="tbl">
      <thead>
        <tr>
          <th class="w-6">
            <a @click="add" class="fas fa-plus-circle" />
          </th>
          <th class="w-24"> Miles </th>
          <slot v-if="groupByRole">
            <th
              v-for="(role, abbrev) in driverTypes"
              :key="abbrev"
              class="w-28"
            >
              {{ role }}
            </th>
          </slot>
          <th v-else class="w-28"> Global </th>
          <th>Type</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rate, index) in rates" :key="index">
          <td>
            <el-popconfirm
              title="Are you sure to delete this mile rates?"
              confirmButtonText="Delete"
              cancelButtonText="Cancel"
              @confirm="remove(index)"
            >
              <a class="fas fa-trash-alt" slot="reference" v-on:click.stop />
            </el-popconfirm>
          </td>
          <td class="text-center">
            <el-input-number
              size="mini"
              :precision="0"
              :step="1"
              :min="0"
              :controls="false"
              v-model="rate.miles"
              style="width: 80px"
            />
          </td>
          <slot v-if="groupByRole">
            <td
              v-for="(role, abbrev) in driverTypes"
              :key="abbrev"
              class="text-center"
            >
              <el-input-number
                v-model="rate[abbrev]"
                size="mini"
                :precision="rate.type == 'per_mile' ? 2 : 1"
                :step="rate.type == 'per_mile' ? 0.01 : 0.1"
                :min="0"
                :controls="false"
                style="width: 100px"
              />
            </td>
          </slot>
          <td v-else class="text-center">
            <el-input-number
              v-model="rate.all"
              size="mini"
              :precision="rate.type == 'per_mile' ? 2 : 1"
              :step="rate.type == 'per_mile' ? 0.01 : 0.1"
              :min="0"
              :controls="false"
              style="width: 100px"
            />
          </td>
          <td class="text-center">
            <el-radio-group v-model="rate.type" size="mini" class="dense">
              <el-radio-button label="flat"> Flat </el-radio-button>
              <el-radio-button label="per_mile"> Per Mile </el-radio-button>
            </el-radio-group>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "DriverMiles",
  props: {
    driver: {
      type: Object,
      required: true,
    },
    driverTypes: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.ensure();
  },
  computed: {
    groupByRole() {
      return this.driver?.group == "role";
    },
    rates() {
      return this.driver?.milerates?.rates || [];
    },
  },
  methods: {
    ensure() {
      if (!this.driver.milerates) {
        this.$set(this.driver, "milerates", { rates: [] });
      } else if (!Array.isArray(this.driver.milerates.rates)) {
        this.$set(this.driver.milerates, "rates", []);
      }
    },
    add() {
      const rate = { miles: 0, all: 0, type: "flat" };
      Object.keys(this.driverTypes).forEach((abbrev) => {
        rate[abbrev] = 0;
      });
      this.driver.milerates.rates.push(rate);
    },
    remove(index) {
      this.driver.milerates.rates.splice(index, 1);
    },
  },
};
</script>
